export default __webpack_public_path__ + "static/media/tickets_Trasnfered.04bd1fab.svg";